import { linkSearchItems } from "components/v2/Listings/ListingsRouterUrlHelper";
import useTranslation from "next-translate/useTranslation";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { selectors as ListingreducerSelectors } from "redux/slices/v2/ListingReducer";
import api_call_v2 from "utils/API_CALL/api_call_v2";
import formatUrl from "utils/FormatUrl";
import classes from "../SaveSearch.module.css";
export const buildLink = (searchPayload, lang, onReturn) => {
  let copySP = {};
  if (window.cartedesannonces) {
    if (window.cartedesannonces.getBounds) {
      let boundsref = window.cartedesannonces.getBounds();
      copySP["lat"] = window.cartedesannonces.getCenter().lat;
      copySP["lng"] = window.cartedesannonces.getCenter().lng;
      copySP["zoom"] = window.cartedesannonces.getZoom();
      copySP["bounds"] = [
        boundsref._sw.lat,
        boundsref._sw.lng,
        boundsref._ne.lat,
        boundsref._ne.lng,
      ];
    }
  } else if (searchPayload.bounds) {
    copySP["bounds"] = [
      searchPayload.bounds._sw.lat,
      searchPayload.bounds._sw.lng,
      searchPayload.bounds._ne.lat,
      searchPayload.bounds._ne.lng,
    ];
  }

  linkSearchItems.map((item) => {
    if (
      (searchPayload[item] && searchPayload[item].length) ||
      (typeof searchPayload[item] == "number" &&
        parseInt(searchPayload[item].toString()))
    ) {
      copySP[item] = searchPayload[item];
    }
  });

  const u = new URLSearchParams(copySP).toString();

  let link = `https://agenz.ma${formatUrl(
    `list.htm${u ? `?${u}` : ""}`,
    lang
  )}`;

  onReturn(link);
  // setCustomLink(link);
  return link;
};
const DropDownComponent = ({ setDropdownToggles, isModal }) => {
  const [dropdownToggle, setDropdownToggle] = useState<boolean>(false);
  const { t, lang } = useTranslation("commonAnnonces");
  const [isMobile, setIsMobile] = useState(true);
  const [displayCopyLink, setDisplayCopyLink] = useState(false);
  const [errorField, setErrorField] = useState(false);
  const [customLink, setCustomLink] = useState("");
  const [copied, setCopied] = useState(false);
  useEffect(() => {
    setDisplayCopyLink(false);
  }, [dropdownToggle]);
  const searchPayload = useSelector(
    ListingreducerSelectors.searchPayloadSelector
  );
  const searchAdresse = useSelector(ListingreducerSelectors.adresseSelector);
  const [inputValue, setInputValue] = useState("");
  useEffect(() => {
    setInputValue(
      searchPayload.exclusivite
        ? "Exclusivités Agenz"
        : `${searchPayload.transaction_type == "Projets Neufs"
          ? t("Projets neufs")
          : searchPayload.transaction_type == "Vente"
            ? t("À vendre")
            : t("À louer")
        } ${searchAdresse
          ? searchAdresse
          : searchPayload.commune
            ? `à ${searchPayload.commune}`
            : searchPayload.province
              ? `à ${searchPayload.province}`
              : searchPayload.region
                ? `à ${searchPayload.region}`
                : ""
        }`
    );
  }, [searchPayload]);
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 990) setIsMobile(true);
      else setIsMobile(false);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  useEffect(() => {
    if (window.innerWidth <= 990) setIsMobile(true);
    else setIsMobile(false);
  }, []);

  const addFilter = (filterName, value) => {
    const first = [filterName, value].join("=");
    return first;
  };

  const arrayToString = (array) => {
    const theCustomString = array.join(",");
    return ["[", theCustomString, "]"].join("");
  };

  const [saving, setSaving] = useState(false);
  const handleUpdateSearch = async () => {
    setSaving(true);

    let link = buildLink(searchPayload, lang, (link) => {
      setCustomLink(link);
    });

    if (inputValue !== "") {
      let bounds = null;
      if (window.cartedesannonces) {
        if (window.cartedesannonces.getBounds) {
          let boundsref = window.cartedesannonces.getBounds();
          bounds = [
            boundsref._sw.lat,
            boundsref._sw.lng,
            boundsref._ne.lat,
            boundsref._ne.lng,
          ];
        }
      } else if (searchPayload.bounds) {
        bounds = [
          searchPayload.bounds._sw.lat,
          searchPayload.bounds._sw.lng,
          searchPayload.bounds._ne.lat,
          searchPayload.bounds._ne.lng,
        ];
      }

      api_call_v2(
        undefined,
        "post",
        "search/save",
        {
          title: inputValue,
          criteria: {
            ...searchPayload,
            bounds: bounds,
            center: searchPayload.lat
              ? [searchPayload.lat, searchPayload.lng]
              : null,
            zoom: searchPayload.zoom ? searchPayload.zoom : null,
            url: link,
          },
        },
        "v3",
        true
      )
        .then((res) => {
          setSaving(false);
          setDisplayCopyLink(true);
        })
        .catch((err) => {
          setSaving(false);
        });
    } else {
      setSaving(false);
      setErrorField(true);
      setDisplayCopyLink(false);
    }
  };

  const copyMail = () => {
    navigator.clipboard.writeText(customLink);
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, 1000);
  };

  return (
    <div className={classes.container}>
      <div className={classes.componentTitle}>
        <span className={classes.title}>
          {t("Sauvegarder votre recherche")}
        </span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
          className={classes.svg_display_mobile}
          onClick={() => {
            setDropdownToggle(false);
            setDropdownToggles(false);
          }}
        >
          <path
            d="M8.46954 6.94546L13.7595 1.65046C13.9234 1.45916 14.009 1.21308 13.9993 0.961404C13.9895 0.709728 13.8852 0.470988 13.7071 0.292894C13.529 0.114799 13.2903 0.0104669 13.0386 0.000745782C12.7869 -0.00897537 12.5408 0.0766307 12.3495 0.240457L7.05454 5.53046L1.75954 0.240457C1.56824 0.0766307 1.32217 -0.00897537 1.07049 0.000745782C0.818814 0.0104669 0.580075 0.114799 0.40198 0.292894C0.223886 0.470988 0.119553 0.709728 0.109832 0.961404C0.100111 1.21308 0.185717 1.45916 0.349544 1.65046L5.63954 6.94546L0.349544 12.2405C0.244862 12.3301 0.159841 12.4404 0.0998179 12.5645C0.0397946 12.6886 0.00606468 12.8237 0.000745182 12.9614C-0.00457431 13.0991 0.0186315 13.2365 0.0689061 13.3648C0.119181 13.4931 0.195439 13.6097 0.292893 13.7071C0.390348 13.8046 0.506896 13.8808 0.635221 13.9311C0.763546 13.9814 0.900878 14.0046 1.0386 13.9993C1.17632 13.9939 1.31145 13.9602 1.43551 13.9002C1.55958 13.8402 1.6699 13.7551 1.75954 13.6505L7.05454 8.36046L12.3495 13.6505C12.5408 13.8143 12.7869 13.8999 13.0386 13.8902C13.2903 13.8804 13.529 13.7761 13.7071 13.598C13.8852 13.4199 13.9895 13.1812 13.9993 12.9295C14.009 12.6778 13.9234 12.4318 13.7595 12.2405L8.46954 6.94546Z"
            fill="black"
          />
        </svg>
      </div>
      <div className={isModal ? classes.headerContainerModal : classes.headerContainer}>
        <div className={classes.titleAndRoomsContainer}>
          <span className={classes.under_title}>
            {t("Nommez votre recherche")}
          </span>
          <input
            className={classes.input_save_search}
            placeholder={t("À Louer à Casablanca")}
            value={inputValue}
            onChange={(e) => {
              setErrorField(false);
              setInputValue(e.target.value);
            }}
          />
          {errorField && (
            <span className={classes.error_field}>{t("Champs requis")}</span>
          )}
        </div>
        <div className={isModal ? classes.validBtnWrapperModal : classes.validBtnWrapper}>
          <button
            className={classes.validBtn}
            onClick={() => {
              handleUpdateSearch();
            }}
          >
            {saving ? (
              <i className="fas fa-circle-notch fa-spin"></i>
            ) : (
              t("Sauvegarder")
            )}
          </button>
        </div>
      </div>

      {displayCopyLink && (
        <div
          className={classes.link_copied}
          style={isModal ? { flexDirection: "column" } : {}}
        >
          <div className={classes.succes_text_icon}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
            >
              <circle cx="10" cy="10" r="10" fill="#32E696" />
              <circle cx="10" cy="10" r="10" fill="black" fillOpacity="0.2" />
              <circle
                cx="10"
                cy="10"
                r="9.5"
                stroke="black"
                stroke-opacity="0.03"
              />
              <path
                d="M15.5672 5.55566L7.70577 13.389L4.43217 10.1271L3.33301 11.2223L7.15619 15.0319L7.70577 15.5557L8.25535 15.0319L16.6663 6.6509L15.5672 5.55566Z"
                fill="white"
              />
            </svg>
            <span className={classes.success_text}>
              {t("Recherche sauvegardée !")}
            </span>
          </div>
          {copied ? (
            <span
              className={`${classes.link_copy_button} ${classes.link_copied_succ}`}
            >
              {t("copié")}
            </span>
          ) : (
            <span
              className={classes.link_copy_button}
              onClick={() => {
                copyMail();
              }}
            >
              {t("Copier le lien")}
            </span>
          )}
        </div>
      )}
    </div>
  );
};

export default DropDownComponent;
